// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"beb32cb8","850":"6e6e3090"}[chunkId] + ".chunk.js";
};